import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=17694bd5&scoped=true&"
import script from "./goodsDetail.js?vue&type=script&lang=js&"
export * from "./goodsDetail.js?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=17694bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17694bd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17694bd5')) {
      api.createRecord('17694bd5', component.options)
    } else {
      api.reload('17694bd5', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=17694bd5&scoped=true&", function () {
      api.rerender('17694bd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goodsDetail/goodsDetail.vue"
export default component.exports